import { KCP_INGEST_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import { KCPIngestItem, KCPIngestDetail } from '../type/kcpIngestType';

class KcpIngestService extends ApiService<KCPIngestItem> {
  constructor() {
    super(KCP_INGEST_API_PATH);
  }

  // Fetch list
  public async fetch(queryParams?: URLSearchParams): Promise<FetchResult<KCPIngestItem>> {
    return super.fetch(queryParams);
  }

  // Fetch detail
  public async fetchOne(id: number): Promise<KCPIngestDetail> {
    return super.fetchById(id);
  }
}

export const kcpIngestService = new KcpIngestService();
